import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import styles from './Contact.module.css';

function Contact() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();

    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_8bq8xjk";
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_3qcj16c";
    const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "z25k1_IPEUf8THpkX";

    emailjs.send(SERVICE_ID, TEMPLATE_ID, {
      email: email,
      message: message
    }, PUBLIC_KEY)
    .then((response) => {
      console.log('Email sent successfully!', response.status, response.text);
      alert('Email sent successfully!');
      clearForm();
    }).catch((error) => {
      console.log('Failed to send email.', error);
      alert('Failed to send email.');
    });
  };

  const clearForm = () => {
    setEmail('');
    setMessage('');
  };

  return (
    <div className={styles.contactContainer}>
      <div className={styles.contactTitle}>Contact Us</div>
      <div className={styles.contactSubtitle}>
        We'd love to hear from you! Fill out the form below and we'll get back to you soon.
      </div>
      <div style={{display: 'flex', flexWrap: 'wrap', gap: '2.5rem', justifyContent: 'center'}}>
        <form id="contactForm" className={styles.contactForm} onSubmit={handleSubmit} style={{flex: 1, minWidth: 270, maxWidth: 340}}>
          <label htmlFor="email" className={styles.contactLabel}>Email</label>
          <input
            type="email"
            id="email"
            name="email"
            className={styles.contactInput}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label htmlFor="message" className={styles.contactLabel}>Message</label>
          <textarea
            id="message"
            name="message"
            rows="6"
            className={styles.contactTextarea}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>
          <button type="submit" className={styles.contactButton}>Send Message</button>
        </form>
        <div className={styles.contactInfo} style={{flex: 1, minWidth: 230, maxWidth: 340}}>
          <div className={styles.contactTitle} style={{fontSize: '1.5rem', marginBottom: '1.2rem'}}>Contact Information</div>
          <div className={styles.infoRow}><span className={styles.infoLabel}>Email:</span> aliveeind@gmail.com</div>
          <div className={styles.infoRow}><span className={styles.infoLabel}>Phone:</span> +91 7977068640</div>
          <div className={styles.infoRow}><span className={styles.infoLabel}>Instagram:</span> rusticyarns.ins</div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
